/**
 * External Dependencies
 */
import 'jquery';

$(document).ready(() => {

    $('[data-yxz]').each(function () {
        const element = $(this),
              prefix = element.data('prefix'),
              key = element.data('key'), // a
              zxy = key.split("").sort().join(""), // b
              yxz = element.data('yxz'); // c
        let   xyz = "";

        for (let e=0; e < yxz.length; e++) {
            xyz += zxy.charAt(key.indexOf(yxz.charAt(e)));
        }

        // Prepare phone numbers
        const link = prefix === 'tel:' ? xyz.replace(/[^0-9+]/g,'') : xyz;

        // Replace attribute or element
        if (element.data('replace')) {
            element.replaceWith("<a href=\"" + prefix + link + "\">" + xyz + "</a>");
        } else {
            element.attr('href', prefix + link);
        }
    });

});
